/**
 * Deterministic seeded RNG (mulberry32).
 *
 * Used only for non-deterministic-feeling effects (mine explosions). Because
 * both the authoritative server and the predicting client run the identical
 * simulator with the same seed, stroke outcomes match exactly.
 */
export class Rng {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  /** Next float in [0, 1). */
  next(): number {
    this.state |= 0;
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Next integer in [min, max]. */
  int(min: number, max: number): number {
    return min + Math.floor(this.next() * (max - min + 1));
  }

  /** Next float in [min, max). */
  float(min: number, max: number): number {
    return min + this.next() * (max - min);
  }
}
